// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunks/" + (chunkId === 7242 ? "bsn-modal" : chunkId) + "." + chunkId + "." + {"1291":"472440db96886b2d4be0","2405":"60cd740f08db89265df0","4238":"6e1e98873b809bcc0f67","7242":"a3ff81cd2b6c1a534f81"}[chunkId] + ".js";
};